var delay_tab = 300,
    delay_show_mm = 300,
    delay_hide_mm = 300;
function mm_destroy(_parent, mmpanel) {
    mmpanel.remember_state || (_parent.find(".mmpanel").toggleClass("mmsubopened mmcurrent mmopened", !1).addClass("mmhidden"), _parent.find("#mm0").addClass("mmopened").addClass("mmcurrent").removeClass("mmhidden")),
        _parent.toggleClass("mmhide mmitemopen", !1).hide(),
        $("body").removeClass("mm-open");
}
function get_mm_parent() {
    return '<div class="mmpanels"></div>';
}
function get_mm_block() {
    return '<div class="mmpanel mmhidden">';
}
function getButtonBack(value, _default) {
    return '<li><a href="#" data-target="#" class="mm-prev-level">' + (value = null == value ? _default : value) + "</a></li>";
}
function getButtonClose(value, _default) {
    return '<li class="mm-close-parent"><a role="button" data-target="#close" class="mm-close">' + (value = null == value ? _default : value) + "</a></li>";
}
function getFullscreenBg() {
    return '<div class="mm-fullscreen-bg"></div>';
}
$("body").append(getFullscreenBg()),
    ($.fn.initMM = function () {
        var mmpanel = {
            $mobilemenu: $(".panel-menu"),
            mm_close_button: "Close",
            mm_back_button: "Back",
            mm_breakpoint: 768,
            mm_enable_breakpoint: !1,
            mm_mobile_button: !1,
            remember_state: !1,
            second_button: !1,
            init: function ($button, data) {
                var _this = this;
                if (!this.$mobilemenu.length) return console.log('You not have <nav class="panel-menu">menu</nav>. See Documentation'), !1;
                null != arguments[1] && this.parse_arguments(data),
                    this.$mobilemenu.parse_mm(mmpanel),
                    this.$mobilemenu.init_mm(mmpanel),
                this.mm_enable_breakpoint && this.$mobilemenu.check_resolution_mm(mmpanel),
                    $button.mm_handler(mmpanel);
            },
            parse_arguments: function (data) {
                var _this = this;
                Object(data).hasOwnProperty("menu_class") && (_this.$mobilemenu = $("." + data.menu_class)),
                    $.each(data, function (k, v) {
                        switch (k) {
                            case "right":
                                v && _this.$mobilemenu.addClass("mm-right");
                                break;
                            case "close_button_name":
                                _this.mm_close_button = v;
                                break;
                            case "back_button_name":
                                _this.mm_back_button = v;
                                break;
                            case "width":
                                _this.$mobilemenu.css("width", v);
                                break;
                            case "breakpoint":
                                _this.mm_breakpoint = v;
                                break;
                            case "enable_breakpoint":
                                _this.mm_enable_breakpoint = v;
                                break;
                            case "mobile_button":
                                _this.mm_mobile_button = v;
                                break;
                            case "remember_state":
                                _this.remember_state = v;
                                break;
                            case "second_button":
                                _this.second_button = v;
                        }
                    });
            },
            show_button_in_mobile: function ($button) {
                var _this = this;
                _this.mm_mobile_button &&
                (window.innerWidth > _this.mm_breakpoint ? $button.hide() : $button.show(),
                    $(window).resize(function () {
                        window.innerWidth > _this.mm_breakpoint ? $button.hide() : $button.show();
                    }));
            },
        };
        mmpanel.init($(this), arguments[0]), mmpanel.show_button_in_mobile($(this));
    }),
    ($.fn.check_resolution_mm = function (mmpanel) {
        var _this = $(this);
        $(window).resize(function () {
            if (!$("body").hasClass("mm-open") || !_this.hasClass("mmitemopen")) return !1;
            window.innerWidth > mmpanel.mm_breakpoint && _this.closemm(mmpanel);
        });
    }),
    ($.fn.mm_handler = function (mmpanel) {
        $(this).click(function (e) {
            $(this).removeClass('not-active').addClass('active');
            e.preventDefault(), mmpanel.$mobilemenu.openmm();
        }),
        0 != mmpanel.second_button &&
        $(mmpanel.second_button).click(function (e) {
            e.preventDefault(), mmpanel.$mobilemenu.openmm();
        });
    }),
    ($.fn.parse_mm = function (mmpanel) {
        var $mm_curent = $(this).clone(),
            $mm_new = $(get_mm_parent()),
            $mm_block = !1,
            count = 0,
            _this = !1,
            $btnBack = !1,
            $ul;
        $(this).empty(),
            $mm_curent.find("a").each(function () {
                (_this = $(this)),
                ($ul = _this.parent().find("ul").first()).length &&
                (count++,
                    $ul.prepend("<li></li>").find("li").first().append(_this.clone().addClass("mm-original-link")),
                    _this
                        .attr('role','button')
                        // .attr("href", "#mm" + count)
                        .attr("data-target", "#mm" + count)
                        .addClass("mm-next-level"));
            }),
            $mm_curent.find("ul").each(function (index) {
                ($btnBack = !1),
                    ($mm_block = $(get_mm_block())
                        .attr("id", "mm" + index)
                        .append($(this))),
                    0 == index
                        ? ($mm_block.addClass("mmopened").addClass("mmcurrent").removeClass("mmhidden"),
                            ($btnBack = getButtonClose($mm_curent.find(".mm-closebtn").html(), mmpanel.mm_close_button)),
                            $mm_block.find("ul").first().prepend($btnBack))
                        : (($btnBack = getButtonBack($mm_curent.find(".mm-backbtn").html(), mmpanel.mm_back_button)), $mm_block.find("ul").first().prepend($btnBack)),
                    $mm_new.append($mm_block);
            }),
            $(this).append($mm_new);
    }),
    ($.fn.init_mm = function (mmpanel) {
        var _parent = $(this);
        _parent.find("a").each(function () {
            $(this).click(function (e) {
                var _this = $(this),
                    $panel = !1,
                    $currobj = !1,
                    lv = "";
                return _this.hasClass("mm-next-level")
                    ? (e.preventDefault(),
                        (lv = _this.attr("data-target")),
                        ($currobj = _parent.find(".mmcurrent")).addClass("mmsubopened").removeClass("mmcurrent"),
                        _parent.find(lv).removeClass("mmhidden"),
                        setTimeout(function () {
                            _parent.find(lv).scrollTop(0).addClass("mmcurrent").addClass("mmopened");
                        }, 0),
                        setTimeout(function () {
                            $currobj.addClass("mmhidden");
                        }, delay_tab),
                        !1)
                    : _this.hasClass("mm-prev-level")
                        ? (e.preventDefault(),
                            (lv = _this.attr("href")),
                            ($currobj = _parent.find(".mmcurrent")).removeClass("mmcurrent").removeClass("mmopened"),
                            _parent.find(".mmsubopened").last().removeClass("mmhidden").scrollTop(0).removeClass("mmsubopened").addClass("mmcurrent"),
                            setTimeout(function () {
                                $currobj.addClass("mmhidden");
                            }, delay_tab),
                            !1)
                        : _this.hasClass("mm-close")
                            ? (_parent.closemm(mmpanel), !1)
                            : void 0;
            });
        }),
            $(".mm-fullscreen-bg").click(function (e) {
                e.preventDefault(), _parent.closemm(mmpanel);
            });
    }),
    ($.fn.openmm = function () {
        var _this = $(this);
        _this.show(),
            setTimeout(function () {
                $("body").addClass("mm-open"), _this.addClass("mmitemopen"), $(".mm-fullscreen-bg").fadeIn(delay_show_mm);
            }, 0);
    }),
    ($.fn.closemm = function (mmpanel) {
        var _this = $(this);
        $('header .mobile button').toggleClass('active not-active')
        _this.addClass("mmhide"),
            $(".mm-fullscreen-bg").fadeOut(delay_hide_mm),
            setTimeout(function () {
                mm_destroy(_this, mmpanel);
            }, delay_hide_mm);
    });
